export default __webpack_public_path__ + "static/media/Lily 9781408304785.ab9d6028.jpg";